import { render, staticRenderFns } from "./bs-row.vue?vue&type=template&id=1156d7d7"
import script from "./bs-row.vue?vue&type=script&lang=ts"
export * from "./bs-row.vue?vue&type=script&lang=ts"
import style0 from "./bs-row.vue?vue&type=style&index=0&id=1156d7d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports